import { render } from "./triggerConfig.vue?vue&type=template&id=50aa93b4&ts=true"
import script from "./triggerConfig.vue?vue&type=script&lang=ts"
export * from "./triggerConfig.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__